import { checkAxiosData, getAxiosConfig } from 'fe-common'
import { from, concatMap, filter, tap } from 'rxjs'

import zhCountries from 'i18n-iso-countries/langs/zh.json'
import enCountries from 'i18n-iso-countries/langs/en.json'
import jaCountries from 'i18n-iso-countries/langs/ja.json'
import koCountries from 'i18n-iso-countries/langs/ko.json'
import ptCountries from 'i18n-iso-countries/langs/pt.json'
import esCountries from 'i18n-iso-countries/langs/es.json'

import { handleMessages, refreshToken } from '../modules/client/utilities'

export default {
  namespaced: true,
  state: () => ({
    wallets: [],
    excludeWallets: [],
    selectedWallet: null,
    countries: [],
    selectedCountry: null
  }),
  actions: {
    getWallets(
      context,
      { gameType, walletType, token, config = {} } = { token: null, config: {} }
    ) {
      const { rootState, commit } = context
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$get(
                `/webapi/game/getEnableWalletList${
                  gameType ? '/' + gameType : ''
                }${walletType ? '/' + walletType : ''}`,
                getAxiosConfig(context, {
                  ...config,
                  headers: {
                    ...config.headers,
                    Authorization:
                      'Bearer ' + (token || rootState.authModule.token)
                  }
                })
              )
            )
          ),
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({
                store: context
              })
            })
          ),
          tap(({ data }) => {
            commit('WALLETS', data)
          })
        )
        .toPromise()
    },
    getExcludeWallets(
      context,
      { walletType = 'deputy', token, config = {} } = {
        walletType: 'deputy',
        token: null,
        config: {}
      }
    ) {
      const { rootState, commit } = context
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$get(
                `/webapi/game/getDisableWalletList${
                  walletType ? '/' + walletType : ''
                }`,
                getAxiosConfig(context, {
                  ...config,
                  headers: {
                    ...config.headers,
                    Authorization:
                      'Bearer ' + (token || rootState.authModule.token)
                  }
                })
              )
            )
          ),
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({
                store: context
              })
            })
          ),
          tap(({ data }) => {
            commit('EXCLUDE_WALLETS', data)
          })
        )
        .toPromise()
    },
    getBalance(context, payload) {
      const data = {
        platform: payload
      }
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/game/getBalance`,
                data,
                getAxiosConfig(context)
              )
            )
          )
        )
        .toPromise()
    },
    transferAllPlatformToWallet(context) {
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/transfer/transferAllOut`,
                {},
                getAxiosConfig(context, { timeout: 10 * 1000 })
              )
            )
          )
        )
        .toPromise()
    },
    getCountries(context) {
      const { commit, state } = context
      commit(
        'COUNTRIES',
        Object.keys(zhCountries.countries).map(countryCode => ({
          countryCode,
          zh: Array.isArray(zhCountries.countries[countryCode])
            ? zhCountries.countries[countryCode].join(', ')
            : zhCountries.countries[countryCode],
          en: Array.isArray(enCountries.countries[countryCode])
            ? enCountries.countries[countryCode].join(', ')
            : enCountries.countries[countryCode],
          ja: Array.isArray(jaCountries.countries[countryCode])
            ? jaCountries.countries[countryCode].join(', ')
            : jaCountries.countries[countryCode],
          ko: Array.isArray(koCountries.countries[countryCode])
            ? koCountries.countries[countryCode].join(', ')
            : koCountries.countries[countryCode],
          pt: Array.isArray(ptCountries.countries[countryCode])
            ? ptCountries.countries[countryCode].join(', ')
            : ptCountries.countries[countryCode],
          es: Array.isArray(esCountries.countries[countryCode])
            ? esCountries.countries[countryCode].join(', ')
            : esCountries.countries[countryCode]
        }))
      )
      commit('SELECTED_COUNTRY', null)
      return Promise.resolve(state.countries)
    }
  },
  mutations: {
    WALLETS(state, payload) {
      state.wallets = payload
    },
    EXCLUDE_WALLETS(state, payload) {
      state.excludeWallets = payload
    },
    SELECTED_WALLET(state, payload) {
      state.selectedWallet = payload
    },
    COUNTRIES(state, payload) {
      state.countries = payload
    },
    SELECTED_COUNTRY(state, payload) {
      state.selectedCountry = payload
    }
  },
  getters: {
    wallets: state => state.wallets,
    excludeWallets: state => state.excludeWallets,
    selectedWallet: state => state.selectedWallet,
    countries: state => state.countries,
    selectedCountry: state => state.selectedCountry
  }
}
